import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Banner } from './types'

export const CREATE_BANNER: TypedDocumentNode<
  { createBanner: Banner },
  {
    client_id: string
    application_id: string
    url?: string | null
    image?: string | null
    position?: number | null
    observations?: string | null
  }
> = gql`
  mutation CreateBanner(
    $client_id: ID!
    $application_id: ID!
    $url: String
    $image: String
    $position: Int
    $observations: String
  ) {
    createBanner(
      client_id: $client_id
      application_id: $application_id
      url: $url
      image: $image
      position: $position
      observations: $observations
    ) {
      id client_id application_id url image image_low_res position observations created_at updated_at
    }
  }
`

export const UPDATE_BANNER: TypedDocumentNode<
  { updateBanner: Banner },
  {
    id: string
    url?: string | null
    image?: string | null
    position?: number | null
    observations?: string | null
  }
> = gql`
  mutation UpdateBanner(
    $id: ID!
    $url: String
    $image: String
    $position: Int
    $observations: String
  ) {
    updateBanner(
      id: $id
      url: $url
      image: $image
      position: $position
      observations: $observations
    ) {
      id client_id application_id url image image_low_res position observations created_at updated_at
    }
  }
`

export const DELETE_BANNER: TypedDocumentNode<{ deleteBanner: boolean }, { id: string }> = gql`
  mutation DeleteBanner($id: ID!) {
    deleteBanner(id: $id)
  }
`
